import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import { Table, ButtonGroup,ButtonToolbar, Button } from 'react-bootstrap';
import Help from '../../../generics/help';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../../generics/modal_person_search';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import { donors_bypatient,getofferbydonornumber } from '../../../../libs/services.js';
import {fileText} from 'react-icons-kit/icomoon/fileText';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import WaitingModal from '../../../generics/WaitingModal.js';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;
require('../../../../assets/datetime-moment.js');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class DonorByPatient extends Component{
	constructor(props){
		super(props);

		this.setTable = this.setTable.bind(this);
		this.updateState = this.updateState.bind(this);
		this.person_search = this.person_search.bind(this);
		this.donor_checked = this.donor_checked.bind(this);
		this.printDonationTicket = this.printDonationTicket.bind(this);
		this.generateExcel = this.generateExcel.bind(this);
		this.handleMasterCheckboxChange = this.handleMasterCheckboxChange.bind(this);

		this.state = {
			health_facilities_id:"",
			listado:[],
			columns:[
				{title:''},
				{title:'Fecha Ofrecimiento'},
				{title:'No. Donante'},
				{title:'Donante'},	
				{title:'T. Extracción'},			
				{title:'Apto/No Apto'},
				{title:'No. Unidad'},
				{title:'Grupo & RH'},
			],
			filename:"Reporte Donantes por Paciente",
			options:[],
			listado:[],
			date_hour:"",

			isLoading:false,
			aptos:"",
			no_aptos:"",
			total:"",
			name:"",
			patient_id: "",
			medical:"",
			listadopdf:[],
			listadoenable:true,
			allSelected: false,
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		this.setTable();
	}

	setTable(){
		$.fn.dataTable.moment( 'DD/MM/YYYY');
		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,5] });				
						doc.content.splice(3, 0, {text: 'Paciente: '+this.state.name, margin:[10,0,0,10] });
						doc.content[4].table.widths=["10%","10%","25%","15%", "10%","15%", "15%"];

						var totales = 'Total Donadores: '+this.state.total+'  -  '+
									'Aptos: '+this.state.aptos+'  -  '+
									'No Aptos: '+this.state.no_aptos;
						doc.content.push({text: totales, margin:[10,10,0,10] });

						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: true,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			initComplete: function () {
			this.api().columns(5).every(function () {
				var column = this;
				var select = $('<select multiple class="form-control form-control-sm"></select>')
				.appendTo($(column.header()).empty())
				.on('change', function () {
					var vals = $(this).val(); 
					if (vals && vals.length) {
						column.search(vals.join('|'), true, false).draw();
					} else {
						column.search('', true, false).draw();
					}
				});
				column.data().unique().sort().each(function (d) {
					if (d) {
						select.append('<option value="'+d+'">'+d+'</option>');
					}
				});
			});

			let api = this.api();
			$(api.column(0).header()).html('<input type="checkbox" id="masterCheck"/>');
			$('#masterCheck').on('click', function () {
				let checked = this.checked;
				api.rows().every(function () {
					let node = this.node();
					$(node).find('input[type="checkbox"]').prop('checked', checked).trigger('change');
				});
			});
			}
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	_handleSearch = (query) => {
	    this.setState({isLoading: true});

		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				for (var i = 0; i < response.length; i++) {

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}

					if(response[i].social_number !== null){
						response[i].names += ' '+response[i].social_number
					}
					
					response[i].id = response[i].person_id;
				};
				this.setState({
					isLoading: false,
			     	options: response
			    });

			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.options.findIndex(obj => 
			    			 parseInt(obj.person.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.updateState([this.state.options[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			})
	}

	updateState(values) {
	    let value = '';
	    if (values.length > 0) {
	      	value = values[0];
	     
	      	this._typeahead.getInstance().blur();

			this.setState({ patient_id: value.patient_id });

	      	this.props.waiting.handleShow('Cargando...');
	      	fetch(Config.default.apiGateway.URL+'reports/donor_by_patient?patient_id='+value.patient_id+
	      		'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{ 
				method: 'post',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
			.then(response => {
				if(response !== undefined){
					var list = [];
					response.offers.map((res)=>{
						list.push([
							moment(res.offer_date).format('DD/MM/YYYY'),
							res.donor_number,
							res.donor_name,
							res.extraction_type,
							res.status,
							res.unit,
							res.group_rh
						])						
					})

					this.setState({
						listado:list, 
						aptos:response.aptos, 
						no_aptos:response.no_aptos, 
						total:response.total,
						name:values[0].names.split(' - ')[0]
					});
					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
				}
			});

	    }
	}

	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}
	donor_checked(e, b) {
		if (e.target.checked) {
		  // Si no existe, agregarlo
		  this.state.listadopdf.push(b);
		  this.setState({listadoenable:false});
		} else {
		  // Si ya existe, quitarlo
		  const helper =this.state.listadopdf.filter(y=>y[1]!=b[1]);
		  this.setState({listadopdf:helper});
		  if (helper.length==0) {
			  this.setState({listadoenable:true})
		  }
		}
	}

	async printPDF(e,listadopdf){
		e.preventDefault();
			   var response = await donors_bypatient(listadopdf,this.state.name,sessionStorage.getItem('health_facilities_id'),  this.state.patient_id);
			   if(response !== undefined){
				 var fileURL = URL.createObjectURL(response);
							 window.open(fileURL);
						 }
			}

			async printDonationTicket(e,donor_number, status){
				e.preventDefault();
				var offer;
				if(status == "APTO ." || status == "APTO ."){
					offer = donor_number
				}
				else{
					offer = await getofferbydonornumber(donor_number,sessionStorage.getItem('health_facilities_id'),10)
				}
				
				console.log(offer);
			   this.waiting_modal.handleShow('Imprimiendo...');
							
				var obj ={};
				var url = '';
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = offer;
				obj.nEtiqueta = [];
				  url='html_templates/print_document';
				  if(status == "APTO ."){
					obj.file_type = 'ticket_valid_donor_entries';
				  }
				  else{
					obj.file_type = 'ticket_valid_donor';
				  }
				  
			
				  var type = await this.props.getDocumentType(obj.file_type);
				  console.log(type);
				  var document;
				  if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				  }else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				  }
				  if(document !== undefined){
					this.waiting_modal.handleClose();
					this.setState({ show: false});
				  }else{
					this.waiting_modal.handleClose();
				  }
			  }
			  generateExcel(e,listadopdf){
				e.preventDefault();
		
				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					health_facilities_id:this.state.health_facilities_id
				};
		
				fetch(Config.default.apiGateway.URL+'reports/generate_excel/listadobydonor?name='+this.state.name,{
					method:'POST',
					body:JSON.stringify(listadopdf),
					responseType: 'blob',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.blob();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response =>{
					if(response !== undefined){
						this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
					}
				})
			}

	
	handleMasterCheckboxChange(e) {
		const isChecked = e.target.checked;
		
		this.setState({
			allSelected: isChecked,
			listadopdf: isChecked ? [...this.state.listado] : [],
			listadoenable: !isChecked
		});
	}

	donor_checked(e, b) {
		if (e.target.checked) {
		  // Si no existe, agregarlo
		  const updatedList = [...this.state.listadopdf, b];
		  this.setState({
			  listadopdf: updatedList,
			  listadoenable: updatedList.length === 0,
			  allSelected: updatedList.length === this.state.listado.length
		  });
		} else {
		  // Si ya existe, quitarlo
		  const updatedList = this.state.listadopdf.filter(y => y[1] !== b[1]);
		  this.setState({
			  listadopdf: updatedList,
			  listadoenable: updatedList.length === 0,
			  allSelected: false
		  });
		}
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					Donantes por Paciente
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_donors_by_patient"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 form-group">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									

									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-7">
											<span className="span-min">{t('content.generics.buttons.search')}</span>
									        <AsyncTypeahead
									          	labelKey={(option) => `${option.names}`}
									          	minLength={5}
									          	name="patient"
									          	id="patient"
									          	onSearch={this._handleSearch}
									          	placeholder="Buscar por apellidos más nombre o número de documento..."
									          	options={this.state.options}
									          	onChange={this.updateState}
									          	ref={ref => this._typeahead = ref}
									          	useCache={false}
									          	isLoading={this.state.isLoading}
									          	delay={800}
									          	paginationText="Mostrar mas resultados..."
									        />
										</div>

										<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
											<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
												onClick={this.person_search}/>
										</div>

										<div className="col-xs-12 col-sm-4" style={{marginTop:'20px'}}>
											<span style={{marginLeft:"5px"}}>
												Fecha de emisión: 
												<b style={{marginLeft:"5px"}}>{this.state.date_hour}</b>
											</span>
										</div>
									</div>
									
								</div>
								
								<Button className="btn btn-info ml-3" onClick={(e)=>this.printPDF(e,this.state.listadopdf)} disabled={this.state.listadoenable} style={{float:"right"}}>
                                        <SvgIcon icon={filePdf}/>Imprimir pdf
								</Button>
								<Button className="btn btn-info" onClick={(e)=>this.generateExcel(e,this.state.listadopdf)} disabled={this.state.listadoenable} style={{float:"right"}}>
                                        <SvgIcon icon={filePdf}/>Imprimir excel
								</Button>
								<div className="col-xs-12 form-group mt-4">
								
								{/* <div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>*/}
									<Table responsive hover>
									<thead>
                                <tr>
									<th>
										<input 
											type="checkbox" 
											checked={this.state.allSelected}
											onChange={this.handleMasterCheckboxChange}
											disabled={this.state.listado.length === 0}
										/>
									</th>
								<th >Fecha Ofrecimiento</th>
								<th >No. Donante</th>
								<th >Donante</th>
								<th >T. Extracción</th>
								<th >Apto/No Apto</th>
								<th >No. Unidad</th>
								<th >Grupo & RH</th>
								<th></th>
								</tr>
                                </thead>
								<tbody>
								{this.state.listado.map((b,i)=>(
									<tr key={i}>
										<td>
											<input 
												type="checkbox"  
												checked={this.state.listadopdf.some(y => y[1] === b[1])}
												onChange={(e)=>this.donor_checked(e,b)} 
											/>
										</td>
                                        <td>{b[0]}</td>
                                        <td>{b[1]}</td>
                                        <td>{b[2]}</td>
										<td>{b[3]}</td>
										<td>{b[4]}</td>
										<td>{b[5]}</td>
										<td>{b[6]}</td>
										<td><FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} 
                      disabled={b[1]===0  ? true : false} 
                      title="Comprobante Donación" mini={true} style={{marginLeft:"5px"}} 
                         onClick={(e)=>this.printDonationTicket(e,b[1], b[4])}
						>
                        <SvgIcon icon={fileText} className={"icon-align"} style={{color:'#aeabab'}}/>
                    </FloatingActionButton></td>
                                    </tr>
								))}
								</tbody>
									</Table>
								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<span className="span-min">Total Donadores: </span>{' '+this.state.total}
									<span className="span-min" style={{marginLeft:"5px"}}>Aptos: </span>{' '+this.state.aptos}
									<span className="span-min" style={{marginLeft:"5px"}}>No Aptos: </span>{' '+this.state.no_aptos}

								</div>
							</div>
						</form>
					</div>
				</div>

				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.updateState} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.updateState}
					persons={this.state.options}
				/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations') (DonorByPatient);